<template>
  <div class="button-banners-wrap">
    <div class="button-banners container-fluid">

      <div class="d-md-flex packages-btn justify-content-md-center">
        <div class="mx-3" v-if="showMediaPackage">
          <PackageButton
              :title="$t('pages.checkins_detail.package_photos_btn_buy_all')"
              :subtitle="$t('pages.checkins_detail.package_banner_subtitle')"
              :extra-class="'btn-buy--package-photos'"
              :price="packagePriceList.price"
              :disabled="isMediaPackageInCart"
              @click="activatePackage"
              v-if="packagePriceList" />
        </div>
      </div>
    </div>
  </div>


</template>

<script>
import {observeElement} from "@/utils/media";
import {mapGetters} from "vuex";
import PackageButton from "@/domain/galleries/components/PackageButton.vue";
import {orderTypes} from "@/domain/cart/constants";

export default {
  name: "PackageButtons",
  emits: ['activate-package'],
  components: {PackageButton},
  props: {
    packagePriceList: {
      type: Object,
      required: false
    }
  },
  computed: {
    ...mapGetters('checkinDetail', ['checkin', 'picaCode', 'eventName', 'currency']),
    ...mapGetters('cartDigitalItems', ['getDigitalItemByPicaCode']),
    showMediaPackage() {
      return !this.isMediaPackageInCart
    },
    isMediaPackageInCart() {
      const digitalItem = this.getDigitalItemByPicaCode(this.picaCode)
      return digitalItem && digitalItem.order_type ? digitalItem.order_type.includes(orderTypes.PHOTOPACKAGE) : false
    },
  },
  async mounted() {
    await observeElement(this.$el)
  },
  methods: {
    activatePackage() {
      this.$emit('activate-package')
    }
  }
}
</script>

<style scoped>

</style>